import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d1541c76")

_pushScopeId("data-v-d1541c76")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex top-button-group" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "新增配件", -1)
const _hoisted_4 = { class: "flex alignC" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "状态", -1)
const _hoisted_6 = { class: "flex alignC" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "分类", -1)
const _hoisted_8 = { class: "flex alignC" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "品牌", -1)
const _hoisted_10 = { class: "flex button-group" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "修改", -1)
const _hoisted_12 = { class: "c-red" }
const _hoisted_13 = { class: "flex flexR mar-t-22" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("报价锁定")
const _hoisted_15 = { class: "c-30" }
const _hoisted_16 = { class: "c-30" }
const _hoisted_17 = { class: "dialog-footer" }
const _hoisted_18 = { class: "c-ff" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "取 消", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.roleList.create)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "bg-red mar-r-18",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogFormVisible = true))
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_el_select, {
          class: "mar-r-8",
          style: {"width":"108px"},
          modelValue: _ctx.selectGroup.status,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectGroup.status = $event)),
          placeholder: "请选择",
          clearable: "",
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectChange($event, 'status')))
        }, {
          default: _withId(() => [
            _createVNode(_component_el_option, {
              label: "启用",
              value: "1"
            }),
            _createVNode(_component_el_option, {
              label: "禁用",
              value: "2"
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_select, {
          class: "mar-r-8",
          style: {"width":"156px"},
          modelValue: _ctx.selectGroup.set,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectGroup.set = $event)),
          placeholder: "请选择",
          clearable: "",
          onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectChange($event, 'set')))
        }, {
          default: _withId(() => [
            _createVNode(_component_el_option, {
              label: "已设置施工提成",
              value: "1"
            }),
            _createVNode(_component_el_option, {
              label: "已设置销售提成",
              value: "2"
            }),
            _createVNode(_component_el_option, {
              label: "已设置锁定报价",
              value: "3"
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_select, {
          class: "mar-r-8",
          style: {"width":"100px"},
          modelValue: _ctx.selectGroup.return_cash_plan,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectGroup.return_cash_plan = $event)),
          placeholder: "请选择",
          clearable: "",
          onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectChange($event, 'return_cash_plan')))
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.reappearance_type_data, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: item.reappearance_type_name,
                value: item.reappearance_type_id,
                key: item.reappearance_type_id
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_el_select, {
          class: "mar-r-8",
          style: {"width":"100px"},
          modelValue: _ctx.selectGroup.mountings_type_pid,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectGroup.mountings_type_pid = $event)),
          clearable: "",
          placeholder: "请选择",
          onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectChange($event, 'mountings_type_pname')))
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.mountings_ptype_data, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: item.name,
                value: item.id,
                key: item.id
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_select, {
          class: "mar-r-8",
          style: {"width":"100px"},
          modelValue: _ctx.selectGroup.mountings_type_id,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectGroup.mountings_type_id = $event)),
          placeholder: "请选择",
          clearable: "",
          disabled: _ctx.selectGroup.mountings_type_pname === '',
          onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectChange($event, 'mountings_type_name')))
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.mountings_type_data, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: item.name,
                value: item.id,
                key: item.id
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"])
      ]),
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_el_select, {
          class: "mar-r-8",
          style: {"width":"100px"},
          modelValue: _ctx.selectGroup.mountings_brand_id,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectGroup.mountings_brand_id = $event)),
          filterable: "",
          clearable: "",
          placeholder: "请选择",
          remote: "",
          "remote-method": _ctx.remoteBrand,
          loading: _ctx.remote_loading,
          onBlur: _cache[13] || (_cache[13] = ($event: any) => (_ctx.brandBlur(true))),
          onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.selectChange($event, 'mountings_brand_name')))
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.mountings_brand_data, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: item.name,
                value: item.id,
                key: item.id
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "remote-method", "loading"]),
        _createVNode(_component_el_input, {
          style: {"width":"202px"},
          modelValue: _ctx.selectGroup.search,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.selectGroup.search = $event)),
          placeholder: "名称/规格/编码",
          clearable: "",
          "suffix-icon": "el-icon-search",
          onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.selectChange($event,'search')))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.tableData,
      stripe: "",
      style: {"width":"100%"},
      class: "table",
      "header-cell-style": _ctx.headClass
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            align: "center",
            prop: item.prop,
            label: item.label,
            "min-width": item.width,
            key: index
          }, null, 8, ["prop", "label", "min-width"]))
        }), 128)),
        _createVNode(_component_el_table_column, {
          label: "操作",
          align: "center",
          "min-width": "120"
        }, {
          default: _withId((scope) => [
            _createVNode("div", _hoisted_10, [
              (_ctx.roleList.edit)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    onClick: ($event: any) => (_ctx.columnChange(scope.row, true))
                  }, {
                    default: _withId(() => [
                      _hoisted_11
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.roleList.disable)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    onClick: ($event: any) => (_ctx.columnChange(scope.row, false))
                  }, {
                    default: _withId(() => [
                      _createVNode("span", _hoisted_12, _toDisplayString(scope.row.status == 0 ? "启用" : "禁用"), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "header-cell-style"]), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode("div", _hoisted_13, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20,50,100],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      title: _ctx.dialogTitle,
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_ctx.dialogFormVisible = $event)),
      center: "",
      width: 1000
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_17, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: _ctx.submitForm
          }, {
            default: _withId(() => [
              _createVNode("span", _hoisted_18, _toDisplayString(_ctx.isEdit ? "保存" : "立即创建"), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.dialogFormVisible = false))
          }, {
            default: _withId(() => [
              _hoisted_19
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          rules: _ctx.rules,
          ref: "formRef",
          inline: true
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              class: "width-40",
              label: "配件名称",
              prop: "name",
              "label-width": "100px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  class: "dialog-input",
                  modelValue: _ctx.form.name,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.form.name = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "配件分类",
              "label-width": "100px",
              prop: "mountings_type_pid"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  class: "mar-r-18 dialog-input",
                  modelValue: _ctx.form.mountings_type_pid,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.form.mountings_type_pid = $event)),
                  placeholder: "请选择",
                  onChange: _ctx.formSelectChange
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.mountings_ptype_data, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: item.id,
                        key: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"]),
                _createVNode(_component_el_select, {
                  class: "dialog-input",
                  modelValue: _ctx.form.mountings_type_id,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.form.mountings_type_id = $event)),
                  placeholder: "请选择",
                  disabled: !_ctx.form.mountings_type_pid
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.mountings_type_data, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: item.id,
                        key: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "width-40",
              label: "成本价",
              prop: "cost_price",
              "label-width": "100px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  class: "dialog-input",
                  modelValue: _ctx.form.cost_price,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.form.cost_price = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "销售价",
              "label-width": "100px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  class: "dialog-input mar-r-8",
                  modelValue: _ctx.form.selling_price,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.form.selling_price = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withId(() => [
                _createVNode(_component_el_radio, {
                  onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (
                            _ctx.form.price_lock = _ctx.form.price_lock == 1 ? 0 : 1
                        ), ["prevent"])),
                  modelValue: _ctx.form.price_lock,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.form.price_lock = $event)),
                  label: 1
                }, {
                  default: _withId(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "width-40",
              label: "配件品牌",
              "label-width": "100px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  class: "dialog-input",
                  modelValue: _ctx.form.mountings_brand_id,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.form.mountings_brand_id = $event)),
                  filterable: "",
                  placeholder: "请选择",
                  remote: "",
                  "remote-method": _ctx.remoteBrand,
                  loading: _ctx.remote_loading,
                  onBlur: _cache[25] || (_cache[25] = ($event: any) => (_ctx.brandBlur(false)))
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.mountings_brand_data, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: item.id,
                        key: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "remote-method", "loading"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "规格",
              "label-width": "100px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  class: "dialog-input",
                  modelValue: _ctx.form.specification,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.form.specification = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "width-40",
              label: "单位",
              "label-width": "100px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  class: "dialog-input",
                  modelValue: _ctx.form.unit_id,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.form.unit_id = $event)),
                  placeholder: "请选择",
                  clearable: ""
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.mountings_unit_data, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: item.id,
                        key: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "width-40",
              label: "编码",
              "label-width": "100px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  class: "dialog-input",
                  modelValue: _ctx.form.encoding,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.form.encoding = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "施工提成",
              "label-width": "100px",
              class: "width-40"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  class: "dialog-select-min",
                  modelValue: _ctx.form.build_bonus_type,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.form.build_bonus_type = $event)),
                  placeholder: "请选择",
                  onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.bonusSelectChange(true)))
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.commissionType, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item,
                        value: index + 1,
                        key: index
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_input, {
                  class: "dialog-input-min",
                  modelValue: _ctx.form.build_bonus_price,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.form.build_bonus_price = $event))
                }, {
                  suffix: _withId(() => [
                    _createVNode("span", _hoisted_15, _toDisplayString(_ctx.form.build_bonus_type == 1 ? "元" : "%"), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "销售提成",
              "label-width": "100px",
              class: "width-40"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  class: "dialog-select-min",
                  modelValue: _ctx.form.sell_bonus_type,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.form.sell_bonus_type = $event)),
                  placeholder: "请选择",
                  onChange: _cache[33] || (_cache[33] = ($event: any) => (_ctx.bonusSelectChange(false)))
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.commissionType, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item,
                        value: index + 1,
                        key: index
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_input, {
                  class: "dialog-input-min",
                  modelValue: _ctx.form.sell_bonus_price,
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.form.sell_bonus_price = $event))
                }, {
                  suffix: _withId(() => [
                    _createVNode("span", _hoisted_16, _toDisplayString(_ctx.form.sell_bonus_type == 1 ? "元" : "%"), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "width-40",
              label: "返现方案",
              "label-width": "100px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  class: "dialog-input",
                  modelValue: _ctx.form.return_cash_plan,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.form.return_cash_plan = $event)),
                  placeholder: "请选择"
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.reappearance_type_data, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.reappearance_type_name,
                        value: item.reappearance_type_id,
                        key: item.reappearance_type_id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "width-40",
              label: "是否预警",
              "label-width": "100px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  class: "dialog-input",
                  modelValue: _ctx.form.is_warning,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.form.is_warning = $event)),
                  placeholder: "请选择"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_option, {
                      label: "是",
                      value: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "否",
                      value: 0
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "width-full",
              label: "描述",
              "label-width": "100px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  class: "dialog-input",
                  modelValue: _ctx.form.describe,
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.form.describe = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]))
})